export const countries = [
  {
    "country": "AX",
    "name": "Aland Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AL",
    "name": "Albania",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AD",
    "name": "Andorra",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AU",
    "name": "Australia",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "ACT",
        "name": "Australian Capital Territory"
      },
      {
        "state": "NSW",
        "name": "New South Wales"
      },
      {
        "state": "NT",
        "name": "Northern Territory"
      },
      {
        "state": "QLD",
        "name": "Queensland"
      },
      {
        "state": "SA",
        "name": "South Australia"
      },
      {
        "state": "TAS",
        "name": "Tasmania"
      },
      {
        "state": "VIC",
        "name": "Victoria"
      },
      {
        "state": "WA",
        "name": "Western Australia"
      }
    ],
    "currency": "USD",
    "pricelist": "20",
    "market": "4"
  },
  {
    "country": "AT",
    "name": "Austria",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BY",
    "name": "Belarus",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BE",
    "name": "Belgium",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BA",
    "name": "Bosnia and Herzegovina",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BG",
    "name": "Bulgaria",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IC",
    "name": "Canary Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CN",
    "name": "China",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "AH",
        "name": "Anhui Sheng"
      },
      {
        "state": "BJ",
        "name": "Beijing Shi"
      },
      {
        "state": "CQ",
        "name": "Chongqing Shi"
      },
      {
        "state": "FJ",
        "name": "Fujian Sheng"
      },
      {
        "state": "GS",
        "name": "Gansu Sheng"
      },
      {
        "state": "GD",
        "name": "Guangdong Sheng"
      },
      {
        "state": "GX",
        "name": "Guangxi Zhuangzu Zizhiqu"
      },
      {
        "state": "GZ",
        "name": "Guizhou Sheng"
      },
      {
        "state": "HI",
        "name": "Hainan Sheng"
      },
      {
        "state": "HE",
        "name": "Hebei Sheng"
      },
      {
        "state": "HL",
        "name": "Heilongjiang Sheng"
      },
      {
        "state": "HA",
        "name": "Henan Sheng"
      },
      {
        "state": "HK",
        "name": "Hong Kong SAR (Xianggang Tebiexingzhengqu)"
      },
      {
        "state": "HB",
        "name": "Hubei Sheng"
      },
      {
        "state": "HN",
        "name": "Hunan Sheng"
      },
      {
        "state": "JS",
        "name": "Jiangsu Sheng"
      },
      {
        "state": "JX",
        "name": "Jiangxi Sheng"
      },
      {
        "state": "JL",
        "name": "Jilin Sheng"
      },
      {
        "state": "LN",
        "name": "Liaoning Sheng"
      },
      {
        "state": "MO",
        "name": "Macau SAR (Aomen Tebiexingzhengqu)"
      },
      {
        "state": "NM",
        "name": "Nei Mongol Zizhiqu"
      },
      {
        "state": "NX",
        "name": "Ningxia Huizu Zizhiqu"
      },
      {
        "state": "QH",
        "name": "Qinghai Sheng"
      },
      {
        "state": "SN",
        "name": "Shaanxi Sheng"
      },
      {
        "state": "SD",
        "name": "Shandong Sheng"
      },
      {
        "state": "SH",
        "name": "Shanghai Shi"
      },
      {
        "state": "SX",
        "name": "Shanxi Sheng"
      },
      {
        "state": "SC",
        "name": "Sichuan Sheng"
      },
      {
        "state": "TW",
        "name": "Taiwan Sheng"
      },
      {
        "state": "TJ",
        "name": "Tianjin Shi"
      },
      {
        "state": "XJ",
        "name": "Xinjiang Uygur Zizhiqu"
      },
      {
        "state": "XZ",
        "name": "Xizang Zizhiqu"
      },
      {
        "state": "YN",
        "name": "Yunnan Sheng"
      },
      {
        "state": "ZJ",
        "name": "Zhejiang Sheng"
      }
    ],
    "currency": "USD",
    "pricelist": "20",
    "market": "4"
  },
  {
    "country": "HR",
    "name": "Croatia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CY",
    "name": "Cyprus",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CZ",
    "name": "Czech Republic",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "DK",
    "name": "Denmark",
    "eu": true,
    "language": "en",
    "currency": "DKK",
    "pricelist": "23",
    "market": "3"
  },
  {
    "country": "EE",
    "name": "Estonia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "FO",
    "name": "Faroe Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "FI",
    "name": "Finland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "FR",
    "name": "France",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "DE",
    "name": "Germany",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GI",
    "name": "Gibraltar",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GR",
    "name": "Greece",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GG",
    "name": "Guernsey",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "VA",
    "name": "Holy See (Vatican City State)",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "HK",
    "name": "Hong Kong",
    "eu": false,
    "language": "en",
    "currency": "USD",
    "pricelist": "20",
    "market": "4"
  },
  {
    "country": "HU",
    "name": "Hungary",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IS",
    "name": "Iceland",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IN",
    "name": "India",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "AN",
        "name": "Andaman and Nicobar Islands"
      },
      {
        "state": "AP",
        "name": "Andhra Pradesh"
      },
      {
        "state": "AR",
        "name": "Arunachal Pradesh"
      },
      {
        "state": "AS",
        "name": "Assam"
      },
      {
        "state": "BR",
        "name": "Bihar"
      },
      {
        "state": "CH",
        "name": "Chandigarh"
      },
      {
        "state": "CT",
        "name": "Chhattisgarh"
      },
      {
        "state": "DN",
        "name": "Dadra and Nagar Haveli"
      },
      {
        "state": "DD",
        "name": "Daman and Diu"
      },
      {
        "state": "DL",
        "name": "Delhi"
      },
      {
        "state": "GA",
        "name": "Goa"
      },
      {
        "state": "GJ",
        "name": "Gujarat"
      },
      {
        "state": "HR",
        "name": "Haryana"
      },
      {
        "state": "HP",
        "name": "Himachal Pradesh"
      },
      {
        "state": "JK",
        "name": "Jammu and Kashmir"
      },
      {
        "state": "JH",
        "name": "Jharkhand"
      },
      {
        "state": "KA",
        "name": "Karnataka"
      },
      {
        "state": "KL",
        "name": "Kerala"
      },
      {
        "state": "LA",
        "name": "Ladakh"
      },
      {
        "state": "LD",
        "name": "Lakshadweep"
      },
      {
        "state": "MP",
        "name": "Madhya Pradesh"
      },
      {
        "state": "MH",
        "name": "Maharashtra"
      },
      {
        "state": "MN",
        "name": "Manipur"
      },
      {
        "state": "ML",
        "name": "Meghalaya"
      },
      {
        "state": "MZ",
        "name": "Mizoram"
      },
      {
        "state": "NL",
        "name": "Nagaland"
      },
      {
        "state": "OR",
        "name": "Odisha"
      },
      {
        "state": "PY",
        "name": "Puducherry"
      },
      {
        "state": "PB",
        "name": "Punjab"
      },
      {
        "state": "RJ",
        "name": "Rajasthan"
      },
      {
        "state": "SK",
        "name": "Sikkim"
      },
      {
        "state": "TN",
        "name": "Tamil Nadu"
      },
      {
        "state": "TG",
        "name": "Telangana"
      },
      {
        "state": "TR",
        "name": "Tripura"
      },
      {
        "state": "UP",
        "name": "Uttar Pradesh"
      },
      {
        "state": "UT",
        "name": "Uttarakhand"
      },
      {
        "state": "WB",
        "name": "West Bengal"
      }
    ],
    "currency": "USD",
    "pricelist": "20",
    "market": "4"
  },
  {
    "country": "IE",
    "name": "Ireland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IM",
    "name": "Isle of Man",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IT",
    "name": "Italy",
    "eu": true,
    "language": "en",
    "states": [
      {
        "state": "AG",
        "name": "Agrigento"
      },
      {
        "state": "AL",
        "name": "Alessandria"
      },
      {
        "state": "AN",
        "name": "Ancona"
      },
      {
        "state": "AO",
        "name": "Aosta"
      },
      {
        "state": "AR",
        "name": "Arezzo"
      },
      {
        "state": "AP",
        "name": "Ascoli Piceno"
      },
      {
        "state": "AT",
        "name": "Asti"
      },
      {
        "state": "AV",
        "name": "Avellino"
      },
      {
        "state": "BA",
        "name": "Bari"
      },
      {
        "state": "BT",
        "name": "Barletta-Andria-Trani"
      },
      {
        "state": "BL",
        "name": "Belluno"
      },
      {
        "state": "BN",
        "name": "Benevento"
      },
      {
        "state": "BG",
        "name": "Bergamo"
      },
      {
        "state": "BI",
        "name": "Biella"
      },
      {
        "state": "BO",
        "name": "Bologna"
      },
      {
        "state": "BZ",
        "name": "Bolzano"
      },
      {
        "state": "BS",
        "name": "Brescia"
      },
      {
        "state": "BR",
        "name": "Brindisi"
      },
      {
        "state": "CA",
        "name": "Cagliari"
      },
      {
        "state": "CL",
        "name": "Caltanissetta"
      },
      {
        "state": "CB",
        "name": "Campobasso"
      },
      {
        "state": "CI",
        "name": "Carbonia-Iglesias"
      },
      {
        "state": "CE",
        "name": "Caserta"
      },
      {
        "state": "CT",
        "name": "Catania"
      },
      {
        "state": "CZ",
        "name": "Catanzaro"
      },
      {
        "state": "CH",
        "name": "Chieti"
      },
      {
        "state": "CO",
        "name": "Como"
      },
      {
        "state": "CS",
        "name": "Cosenza"
      },
      {
        "state": "CR",
        "name": "Cremona"
      },
      {
        "state": "KR",
        "name": "Crotone"
      },
      {
        "state": "CN",
        "name": "Cuneo"
      },
      {
        "state": "EN",
        "name": "Enna"
      },
      {
        "state": "FM",
        "name": "Fermo"
      },
      {
        "state": "FE",
        "name": "Ferrara"
      },
      {
        "state": "FI",
        "name": "Firenze"
      },
      {
        "state": "FG",
        "name": "Foggia"
      },
      {
        "state": "FC",
        "name": "Forlì-Cesena"
      },
      {
        "state": "FR",
        "name": "Frosinone"
      },
      {
        "state": "GE",
        "name": "Genova"
      },
      {
        "state": "GO",
        "name": "Gorizia"
      },
      {
        "state": "GR",
        "name": "Grosseto"
      },
      {
        "state": "IM",
        "name": "Imperia"
      },
      {
        "state": "IS",
        "name": "Isernia"
      },
      {
        "state": "AQ",
        "name": "L'Aquila"
      },
      {
        "state": "SP",
        "name": "La Spezia"
      },
      {
        "state": "LT",
        "name": "Latina"
      },
      {
        "state": "LE",
        "name": "Lecce"
      },
      {
        "state": "LC",
        "name": "Lecco"
      },
      {
        "state": "LI",
        "name": "Livorno"
      },
      {
        "state": "LO",
        "name": "Lodi"
      },
      {
        "state": "LU",
        "name": "Lucca"
      },
      {
        "state": "MC",
        "name": "Macerata"
      },
      {
        "state": "MN",
        "name": "Mantova"
      },
      {
        "state": "MS",
        "name": "Massa-Carrara"
      },
      {
        "state": "MT",
        "name": "Matera"
      },
      {
        "state": "VS",
        "name": "Medio Campidano"
      },
      {
        "state": "ME",
        "name": "Messina"
      },
      {
        "state": "MI",
        "name": "Milano"
      },
      {
        "state": "MO",
        "name": "Modena"
      },
      {
        "state": "MB",
        "name": "Monza e della Brianza"
      },
      {
        "state": "NA",
        "name": "Napoli"
      },
      {
        "state": "NO",
        "name": "Novara"
      },
      {
        "state": "NU",
        "name": "Nuoro"
      },
      {
        "state": "OG",
        "name": "Ogliastra"
      },
      {
        "state": "OT",
        "name": "Olbia-Tempio"
      },
      {
        "state": "OR",
        "name": "Oristano"
      },
      {
        "state": "PD",
        "name": "Padova"
      },
      {
        "state": "PA",
        "name": "Palermo"
      },
      {
        "state": "PR",
        "name": "Parma"
      },
      {
        "state": "PV",
        "name": "Pavia"
      },
      {
        "state": "PG",
        "name": "Perugia"
      },
      {
        "state": "PU",
        "name": "Pesaro e Urbino"
      },
      {
        "state": "PE",
        "name": "Pescara"
      },
      {
        "state": "PC",
        "name": "Piacenza"
      },
      {
        "state": "PI",
        "name": "Pisa"
      },
      {
        "state": "PT",
        "name": "Pistoia"
      },
      {
        "state": "PN",
        "name": "Pordenone"
      },
      {
        "state": "PZ",
        "name": "Potenza"
      },
      {
        "state": "PO",
        "name": "Prato"
      },
      {
        "state": "RG",
        "name": "Ragusa"
      },
      {
        "state": "RA",
        "name": "Ravenna"
      },
      {
        "state": "RC",
        "name": "Reggio Calabria"
      },
      {
        "state": "RE",
        "name": "Reggio Emilia"
      },
      {
        "state": "RI",
        "name": "Rieti"
      },
      {
        "state": "RN",
        "name": "Rimini"
      },
      {
        "state": "RM",
        "name": "Roma"
      },
      {
        "state": "RO",
        "name": "Rovigo"
      },
      {
        "state": "SA",
        "name": "Salerno"
      },
      {
        "state": "SS",
        "name": "Sassari"
      },
      {
        "state": "SV",
        "name": "Savona"
      },
      {
        "state": "SI",
        "name": "Siena"
      },
      {
        "state": "SR",
        "name": "Siracusa"
      },
      {
        "state": "SO",
        "name": "Sondrio"
      },
      {
        "state": "SU",
        "name": "Sud Sardegna"
      },
      {
        "state": "TA",
        "name": "Taranto"
      },
      {
        "state": "TE",
        "name": "Teramo"
      },
      {
        "state": "TR",
        "name": "Terni"
      },
      {
        "state": "TO",
        "name": "Torino"
      },
      {
        "state": "TP",
        "name": "Trapani"
      },
      {
        "state": "TN",
        "name": "Trento"
      },
      {
        "state": "TV",
        "name": "Treviso"
      },
      {
        "state": "TS",
        "name": "Trieste"
      },
      {
        "state": "UD",
        "name": "Udine"
      },
      {
        "state": "VA",
        "name": "Varese"
      },
      {
        "state": "VE",
        "name": "Venezia"
      },
      {
        "state": "VB",
        "name": "Verbano-Cusio-Ossola"
      },
      {
        "state": "VC",
        "name": "Vercelli"
      },
      {
        "state": "VR",
        "name": "Verona"
      },
      {
        "state": "VV",
        "name": "Vibo Valentia"
      },
      {
        "state": "VI",
        "name": "Vicenza"
      },
      {
        "state": "VT",
        "name": "Viterbo"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "JP",
    "name": "Japan",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "23",
        "name": "Aichi"
      },
      {
        "state": "05",
        "name": "Akita"
      },
      {
        "state": "02",
        "name": "Aomori"
      },
      {
        "state": "12",
        "name": "Chiba"
      },
      {
        "state": "38",
        "name": "Ehime"
      },
      {
        "state": "18",
        "name": "Fukui"
      },
      {
        "state": "40",
        "name": "Fukuoka"
      },
      {
        "state": "07",
        "name": "Fukushima"
      },
      {
        "state": "21",
        "name": "Gifu"
      },
      {
        "state": "10",
        "name": "Gunma"
      },
      {
        "state": "34",
        "name": "Hiroshima"
      },
      {
        "state": "01",
        "name": "Hokkaido"
      },
      {
        "state": "28",
        "name": "Hyogo"
      },
      {
        "state": "08",
        "name": "Ibaraki"
      },
      {
        "state": "17",
        "name": "Ishikawa"
      },
      {
        "state": "03",
        "name": "Iwate"
      },
      {
        "state": "37",
        "name": "Kagawa"
      },
      {
        "state": "46",
        "name": "Kagoshima"
      },
      {
        "state": "14",
        "name": "Kanagawa"
      },
      {
        "state": "39",
        "name": "Kochi"
      },
      {
        "state": "43",
        "name": "Kumamoto"
      },
      {
        "state": "26",
        "name": "Kyoto"
      },
      {
        "state": "24",
        "name": "Mie"
      },
      {
        "state": "04",
        "name": "Miyagi"
      },
      {
        "state": "45",
        "name": "Miyazaki"
      },
      {
        "state": "20",
        "name": "Nagano"
      },
      {
        "state": "42",
        "name": "Nagasaki"
      },
      {
        "state": "29",
        "name": "Nara"
      },
      {
        "state": "15",
        "name": "Niigata"
      },
      {
        "state": "44",
        "name": "Oita"
      },
      {
        "state": "33",
        "name": "Okayama"
      },
      {
        "state": "47",
        "name": "Okinawa"
      },
      {
        "state": "27",
        "name": "Osaka"
      },
      {
        "state": "41",
        "name": "Saga"
      },
      {
        "state": "11",
        "name": "Saitama"
      },
      {
        "state": "25",
        "name": "Shiga"
      },
      {
        "state": "32",
        "name": "Shimane"
      },
      {
        "state": "22",
        "name": "Shizuoka"
      },
      {
        "state": "09",
        "name": "Tochigi"
      },
      {
        "state": "36",
        "name": "Tokushima"
      },
      {
        "state": "13",
        "name": "Tokyo"
      },
      {
        "state": "31",
        "name": "Tottori"
      },
      {
        "state": "16",
        "name": "Toyama"
      },
      {
        "state": "30",
        "name": "Wakayama"
      },
      {
        "state": "06",
        "name": "Yamagata"
      },
      {
        "state": "35",
        "name": "Yamaguchi"
      },
      {
        "state": "19",
        "name": "Yamanashi"
      }
    ],
    "currency": "USD",
    "pricelist": "20",
    "market": "4"
  },
  {
    "country": "JE",
    "name": "Jersey",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KR",
    "name": "Korea, Republic of",
    "eu": false,
    "language": "en",
    "currency": "USD",
    "pricelist": "20",
    "market": "4"
  },
  {
    "country": "XK",
    "name": "Kosovo",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LV",
    "name": "Latvia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LI",
    "name": "Liechtenstein",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LT",
    "name": "Lithuania",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LU",
    "name": "Luxembourg",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MO",
    "name": "Macau",
    "eu": false,
    "language": "en",
    "currency": "USD",
    "pricelist": "20",
    "market": "4"
  },
  {
    "country": "MT",
    "name": "Malta",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MD",
    "name": "Moldova, Republic of",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MC",
    "name": "Monaco",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ME",
    "name": "Montenegro",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NL",
    "name": "Netherlands",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NZ",
    "name": "New Zealand",
    "eu": false,
    "language": "en",
    "currency": "USD",
    "pricelist": "20",
    "market": "4"
  },
  {
    "country": "MK",
    "name": "North Macedonia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NO",
    "name": "Norway",
    "eu": false,
    "language": "en",
    "currency": "NOK",
    "pricelist": "24",
    "market": "1"
  },
  {
    "country": "PL",
    "name": "Poland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PT",
    "name": "Portugal",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "RO",
    "name": "Romania",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SM",
    "name": "San Marino",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "RS",
    "name": "Serbia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SG",
    "name": "Singapore",
    "eu": false,
    "language": "en",
    "currency": "USD",
    "pricelist": "20",
    "market": "4"
  },
  {
    "country": "SK",
    "name": "Slovakia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SI",
    "name": "Slovenia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ES",
    "name": "Spain",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SJ",
    "name": "Svalbard",
    "eu": false,
    "language": "en",
    "currency": "NOK",
    "pricelist": "24",
    "market": "1"
  },
  {
    "country": "SE",
    "name": "Sweden",
    "eu": true,
    "language": "en",
    "currency": "SEK",
    "pricelist": "19",
    "market": "3"
  },
  {
    "country": "CH",
    "name": "Switzerland",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "UA",
    "name": "Ukraine",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GB",
    "name": "United Kingdom",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "GB-ENG",
        "name": "England"
      },
      {
        "state": "GB-NIR",
        "name": "Northern Ireland"
      },
      {
        "state": "GB-SCT",
        "name": "Scotland"
      },
      {
        "state": "GB-WLS",
        "name": "Wales"
      }
    ],
    "currency": "GBP",
    "pricelist": "25",
    "market": "3"
  }
];